import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=1c23ca18"
import script from "./EditIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./EditIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports